import React, { useEffect, useMemo, useState } from 'react';
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import Button from '../../../../../components/button';
import Loading from '../../../../../components/loading';
import styles from '../../initiateForm/form.module.scss';
import { GetFileName, S3Uploads } from '../../../../services';
import Collapsible from '../../../../../components/collapsible/Collapsible';
import CustomFields from '../../../../../components/customFields/CustomFields';
import { submitDp, saveAsDraft, getApplicationDetails, checkExistingApprovedApplication,
  handleClearApprovedApplicationState, deleteSaveAsDraftAdpLog,
  clearDraftState, getAdpCategories
 } from '../../../redux/action';
import { getThreeLetterCountryCode } from '../../../../../utils/helpers';
import ReqAttachments from '../../Components/ReqAttachments';
import DeleteConfirmation from '../../../../../components/deleteConfirmation/deleteConfirmation';
import { getFeeWithInvoice, SaveAlert } from '../../../components/ActionCompo';
import { handleSignature, valueType } from '../../../components/PermitData';

const AdpDriverPublicForm = (props) => {
  const { changePage, airportCode, translation, orderId, selectedCategory, applicationDetails, isPaymentAvailable, match,
     handleSaveCategoryFee, adpSchemaSettings } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const profile = useSelector(state => state.auth.profile);
  const userProfile = useSelector(state => state?.permitManagement?.userData);
  const existingApprovedAppInfo = useSelector(state => state?.permitManagement?.approvedApplicationData);
  const checkApprovedApplicationAction = useSelector(state => state?.permitManagement?.checkApprovedApplicationAction);
  const actionSaveAsDraft = useSelector(state => state?.permitManagement?.actionSaveAsDraft);
  const existAnswers = useSelector(state => state?.permitManagement?.userData?.permit);
  const ordering = useSelector(state => state?.permitManagement?.userData?.form?.schema?.ordering);
  const customFields = useSelector(state => state?.permitManagement?.userData?.form?.schema?.fields);
  const renewalFields = useSelector(state => state.permitManagement?.adpRenewalFields);
  const notes = useSelector(state => state?.permitManagement?.userData?.form?.default_fields?.notes);
  const defaultFields = useSelector(state => state?.permitManagement?.userData?.form?.default_fields?.default_field);
  const reqAttach = useSelector(state => state?.permitManagement?.userData?.form?.default_fields?.required_attachements);
  const countrycode = useSelector(state => state.auth.profile.portal_airport.country_code);
  const installationId = useSelector(state => state.auth.profile.portal_airport.backend_id);
  const adpCategories = useSelector(state => state?.permitManagement?.adpCategories);
  const feeTypesList = useSelector(state => state?.permitManagement?.adpFeeWithCategoriesList);
  const submittedDp = useSelector(state => state?.permitManagement?.submittedDp);
  const submitStatus = useSelector(state => state?.permitManagement?.actionSubmitDp);
  const actionDeleteDraftApplication = useSelector(states => states?.permitManagement?.actionDeleteDraftADPApplication);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [alert, setAlert] = useState(false);
  const [load, setLoad] = useState(false);
  const [state, setState] = useState({
    answers: {
      ...existAnswers
    },
    loader: false,
    dateError: false,
    formErrors: false
  });
  const [errors, setErrors] = useState({});
  const [renewalErrors, setRenewalErrors] = useState({});
  const [temp, setTemp] = useState(true);
  const [allFields, setAllFields] = useState([]);
  const [reqErrors, setReqErrors] = useState({});
  const [countryState, setcountryState] = useState([]);
  const [mergedFields, setMergedFields] = useState([]);
  const [disableSign, setDisableSign] = useState(false);
  const [conditionalFields, setConditionalFields] = useState({});


  const staticFields = [
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: false,
      id: 'attachments',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Attachments',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: false,
      id: 'photo',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      isCrop: true,
      system_generated: false,
      title: 'Profile Picture',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'signature',
      isDisabled: disableSign,
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Signature',
      type: 'signature'
    }
  ];

  const defaultIDs = [
    'first_name', 'last_name', 'email', 'phone', 'designation', 'dob', 'company',
    'lic_issue_date', 'lic_exp_date', 'permit_type', 'category_of_adp', 'signature',
    'driving_lic_num', 'type_of_lic', 'issusing_authority', 'employee_id'
  ];

  const isIssuingAuthorityDisabled = defaultFields?.some(field => field.id === 'issusing_authority' && field.isDisabled);

  useEffect(() => {
    dispatch(handleClearApprovedApplicationState());
    dispatch(getAdpCategories(true)); // getting adp categories
    dispatch(getAdpCategories(false, false, false, profile?.current_tenant?.id));
    dispatch(getApplicationDetails(orderId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (defaultFields && customFields) {
      const combinedFields = [...defaultFields, ...customFields];
      let Fields;
      let condFields = {};
      let fieldErros = { ...errors,
        signature: state.answers.signature ? !Object.keys(state.answers?.signature) : true,
        attachments: reqAttach?.length > 0 ? false : !state.answers?.attachments?.length > 0
       };
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering && ordering?.length) {
        Fields = ordering
          .map(oId => filteredFields.find(field => field.id === oId))
          .filter(field => field);
      } else {
        Fields = filteredFields;
      }
      setMergedFields(Fields);
      Fields.forEach((ele) => {
        const { id, required, conditional, conditional_field } = ele;
        if (conditional && conditional_field?.key) {
          const { key } = conditional_field;
          condFields[key] = [...(condFields[key] || []), ele];
        } else if (required) {
          const isDefault = defaultIDs.includes(id);
          const value = isDefault ? state.answers[id] : state.answers.response?.[id];
          fieldErros = { ...fieldErros, [id]: !value };
        }
      });
      setDisableSign(combinedFields?.some(ele => ele.id === 'signature' && ele?.isDisabled === true));
      setConditionalFields(condFields);
      setErrors(fieldErros);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFields]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.answers?.req_attachments, reqAttach]);

  useEffect(() => {
    if (renewalFields?.length > 0) {
      let renewalReq = {};
      renewalFields.forEach((ele) => {
        // checking required fields
        if (ele.required) {
          renewalReq = { ...renewalReq, [ele.id]: !state.answers?.renewal_response?.[ele.id] };
        }
      });
      setRenewalErrors(renewalReq);
    }
  }, [renewalFields, state.answers.renewal_response]);

  useEffect(() => {
    const setIssuingAuthorityOptions = (allStates) => {
      const all = mergedFields?.map((ele) => {
        if (ele.id === 'issusing_authority') {
          return {
            ...ele,
            values: allStates?.map(each => ({
              key: each?.state,
              value: each?.state
            })),
            default_value: {}
          };
        }
        const categoryOptions = allFields.find(field => field.id === 'category_of_adp')?.values?.map(option => option.value) || [];
        if (ele?.id === 'category_of_adp'
            && applicationDetails?.enable_category_training
            && !applicationDetails?.permit?.offline_training
            && categoryOptions.includes(selectedCategory)
          ) {
          return {
            ...ele,
            disable: true
          };
        }
        return ele;
      });
      setAllFields(all);
    };
    if (mergedFields && countryState) {
      setIssuingAuthorityOptions(countryState);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergedFields, countryState]);

  useEffect(() => {
    const fetchCountryStates = async () => {
      if (!defaultFields?.length || isIssuingAuthorityDisabled) return;
      try {
        AWS.config.update({
          region: process.env.REACT_APP_REGION
        });
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
        });
        await AWS.config.credentials.getPromise();
        const docClient = new AWS.DynamoDB.DocumentClient({
          region: process.env.REACT_APP_REGION
        });

        const threeCharCode = getThreeLetterCountryCode(countrycode);
        if (!threeCharCode) return;
        const params = {
          TableName: 'aeros_countries_states',
          KeyConditionExpression: 'country_large_code = :country_large_code',
          ExpressionAttributeValues: {
            ':country_large_code': threeCharCode
          }
        };
        const data = await docClient.query(params).promise();
        setcountryState(data.Items);
      } catch (error) {
          toast.error('Error occured while fetching country states', error);
      }
    };
    fetchCountryStates();
  }, [defaultFields, installationId, countrycode, isIssuingAuthorityDisabled]);

  useEffect(() => {
    if (temp && existAnswers) {
      const all_attachments = existAnswers?.attachments.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = existAnswers?.req_attachments
        && Object.keys(existAnswers?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: existAnswers?.req_attachments[key].map(att => all_attachments[att]) }), {});
      const sign = applicationDetails.signature;
      const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
        || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);
      setState({
        ...state,
        answers: {
          ...existAnswers,
          signature: isEmptySignature ? null : existAnswers.signature,
          req_attachments: requireAttachments
        }
      });
      setTemp(false);
    }
  }, [temp, existAnswers, applicationDetails, state]);

  useEffect(() => {
    if (submittedDp?.permit?.attachments?.length > 0) {
      const obj_att = submittedDp?.permit?.attachments.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const final_req = state.answers?.req_attachments
        && Object.keys(submittedDp?.permit?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: submittedDp?.permit?.req_attachments[key].map(att => obj_att[att]) }), {});
      setState({ ...state, answers: { ...submittedDp?.permit, req_attachments: final_req } });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittedDp]);

  useEffect(() => () => {
    dispatch(clearDraftState());
  }, [dispatch]);

  const getValue = (item) => {
    const idExistsInDefault = defaultIDs.includes(item.id);
    const answer = idExistsInDefault ? state.answers[item?.id] : state.answers.response?.[item?.id];
    return !answer;
  };

  const getDefAnswer = (item) => {
    if (state.answers[item.id]) {
      return state.answers[item.id];
    }
    return valueType(item)?.value;
  };

  const getCusAns = (item) => {
    if (state.answers.response?.[item.id]) {
      return state.answers.response?.[item.id];
    }
    return valueType(item)?.value;
  };

  // Automatically set the category if the 'Category based training' and 'Training' is enabled
  useEffect(() => {
    if (applicationDetails?.enable_category_training
        && !applicationDetails?.permit?.offline_training
        && !adpSchemaSettings?.settings?.disable_driver_permit_online_training && !applicationDetails?.permit?.category_of_adp) {
      handleAnswerChanged('answers', selectedCategory, 'category_of_adp');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.answers?.category_of_adp, selectedCategory]);

  const handleAnswerChanged = (section, answer, fieldId) => {
    if (conditionalFields?.[fieldId]) { // check the conditional fields
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item?.conditional_values;
        const fieldValue = answer;
        const enableCondition = conditionValues.some(value => fieldValue === value?.value);
        const defaultValue = valueType(item)?.value;
        if (item.required) {
          handleFieldErrorChanged(
            item.id,
            enableCondition ? getValue(item) : false
          );
        }
        if (enableCondition) {
          setState(prev => ({
            answers: {
              ...prev.answers,
              ...(defaultIDs.includes(item.id)
                ? { [item.id]: getDefAnswer(item) }
                : { response: { ...prev.answers.response, [item.id]: getCusAns(item) } }
              )
            }
          }));
        } else {
          setState(prev => ({
            answers: {
              ...prev.answers,
              ...(defaultIDs.includes(item.id)
                ? { [item.id]: defaultValue }
                : { response: { ...prev.answers.response, [item.id]: defaultValue } }
              )
            }
          }));
        }
      });
    }
    if (section === 'response') { // check custom field answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          response: {
            ...prevState.answers.response,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments') { // check required attachment answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments: {
            ...prevState.answers.req_attachments,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments_dates') {
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments_details: {
            ...prevState.answers.req_attachments_details,
            [section]: {
              ...prevState.answers.req_attachments_details?.[section],
              [fieldId]: answer
            }
          }
        }
      }));
    } else { // check default field answers
      setState(prevState => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  };

  const handleRenewalAnswerChanged = (answer, fieldId) => {
    setState(prevState => ({
      ...prevState,
      answers: {
        ...prevState.answers,
        renewal_response: {
          ...prevState.answers.renewal_response,
          [fieldId]: answer
        }
      }
    }));
  };


  const handleFieldErrorChanged = (id, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [id]: value }));
  };

  const handleRenewalFieldErrorChanged = (fieldId, value) => {
    setRenewalErrors(prevErr => ({ ...prevErr, [fieldId]: value }));
  };

  const getRequired = (data, isFieldError) => {
    let requiredKeys = {
      signature: true,
      attachments: true
    };
    let FieldError = { ...errors };
    if (data?.length !== 0) {
      data.forEach((ele) => {
        if (ele.required) {
          if (defaultIDs.includes(ele.id)) {
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers[ele.id] };
          } else if (!(defaultIDs.includes(ele.id))) {
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers.response?.[ele.id] };
          }
        }
      });
    }
    return isFieldError ? FieldError : requiredKeys;
  };

  const getRenewalRequired = (Fields) => {
    let requiredKeys = {};
    if (Fields?.length !== 0) {
      Fields.forEach((ele) => {
        // checking required fields
        if (ele.required) {
            requiredKeys = { ...requiredKeys, [ele.id]: true };
        }
      });
    }
    return requiredKeys;
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers.attachments.filter(e => e.attachment_id !== attachment.attachment_id);
    setState({ ...state, answers: { ...state.answers, attachments: filtereAttachments } });
  };

  const getFileNames = async (count, code) => {
    const response = await GetFileName.getPermitUploadFileName(count, code, 'driver_permit');
    return response;
  };

  const doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      installationId,
      airportCode,
      getErrorAlert
    );
    return response;
  };

  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id) {
        oldAttachments.push(e.attachment_id);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length, airportCode);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'driver_permit',
        getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length, airportCode);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'driver_permit', getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  const invoiceObject = useMemo(() => getFeeWithInvoice({
    description: 'On Application Submission',
    feeCategoryData: feeTypesList,
    taxData: adpSchemaSettings?.tax_details,
    applicationType: 'New',
    applicationFor: 'on_application_submission',
    selectedCategory: state.answers?.category_of_adp,
    isVatApplicable: adpSchemaSettings?.isVatApplicable,
    roundTo: 2
  }) || {}, [feeTypesList, adpSchemaSettings, state.answers.category_of_adp]);

  const handelSubmit = async (isDraft, disableCheck) => {
    const { attachments, signature, photo, lic_exp_date, lic_issue_date, dob, req_attachments } = state.answers;
    let error = { ...errors,
      first_name: false,
      last_name: false,
      phone: false,
      category_of_adp: !state.answers?.category_of_adp,
      photo: !state.answers?.photo?.length > 0
     };
    let dataObject = {};
    let newDate = moment().startOf('day');
     // HANDLE APPROVED APPLICATION API BASED ON ADMIN SETTING ENABLED OR NOT
     if (applicationDetails?.disable_more_than_one_approved_permit_adp && !disableCheck && !isDraft
      && applicationDetails?.permit?.application_type !== 'Renewal' // DO NOT CHECK APPLICATION EXISTS OR NOT FOR RENEWAL TYPE
     ) {
      handleCheckApprovedApplication();
      return;
    }

    let noErrors = Object.keys(error).every(k => (
      error[k] === false
    ));
    let noReqErrors = Object.keys(reqErrors).every(k => reqErrors[k] === false);
    let noRenewalErrors = state.answers.application_type === 'Renewal'
      ? Object.keys(renewalErrors).every(k => (renewalErrors[k] === false))
      : true;
    let dateOfBirth = moment(dob);
    let age = newDate.diff(dateOfBirth, 'year', true);
    let issueDate = moment(lic_issue_date);
    let expireDate = moment(lic_exp_date);
    if ((lic_issue_date && issueDate.diff(moment(new Date())) > 0) && !isDraft) {
      setState(prevState => ({
        ...prevState,
        dateError: 'License Issue Date cannot be a future date. Please modify the date and try again.'
      }));
    } else if ((lic_exp_date && expireDate.diff(moment(new Date())) < 0) && !isDraft) {
      setState(prevState => ({
        ...prevState,
        dateError: 'License Expire Date should be a future date. Please modify the date and try again.'
      }));
    } else if (lic_exp_date && lic_issue_date && issueDate.diff(expireDate) > 0 && !isDraft) {
      setState(prevState => ({
        ...prevState,
        dateError: 'License Issued date should not be older than License Expiry date.'
      }));
    } else if (dob && ((dob && age <= 17) && !isDraft)) {
      setState(prevState => ({
        ...prevState,
        dateError: 'Applicant age should be 17 years or above.'
      }));
    } else if ((noErrors && noReqErrors && noRenewalErrors) || isDraft) {
      setState(prevState => ({ ...prevState, loader: true, dateError: '' }));

      // for required attachment id's
      const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
        if (Array.isArray(attachment)) {
          acc[key] = attachment
            .map(item => item?.attachment_id)
            .filter(id => typeof id === 'string');
        } else {
          acc[key] = [];
        }
        return acc;
      }, {});
      const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
        ? attachments.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];
      const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'driver_permit');
      const photoId = (photo?.length > 0 && Array.isArray(photo))
        ? photo.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];

      const customSignFields = allFields.filter(field => field.type === 'signature') || [];

      if (customSignFields.length > 0) {
        for (let index = 0; index < customSignFields.length; index++) {
          const customSignField = customSignFields[index]?.id;
          const schemaField = customSignFields[index];
          const customSignValue = Array.isArray(state.answers?.response?.[customSignField])
            ? state.answers?.response?.[customSignField]
            : !!state.answers?.response?.[customSignField] && [state.answers?.response?.[customSignField]];
          if (schemaField?.type === 'signature' && customSignValue?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            state.answers.response[customSignField] = await handleUploadAttachments(customSignValue, 'driver_permit') || [];
          }
        }
      }

      const attachmentFields = customFields.filter(schemaField => (
        schemaField?.type === 'attachments'
      ));
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && state.answers?.response?.[attachmentField]?.length > 0) {
            state.answers.response[attachmentField] = state.answers.response[attachmentField]
              .map(item => item?.attachment_id)
              .filter(id => typeof id === 'string');
          }
        }
      }
      if (state.answers?.application_type === 'Renewal' && renewalFields?.length > 0) {
        const renewalAttachmentFields = renewalFields.filter(schemaField => (
          schemaField?.type === 'attachments'
        ));
        if (renewalAttachmentFields.length > 0) {
          for (let index = 0; index < renewalAttachmentFields.length; index++) {
            const attachmentField = renewalAttachmentFields[index]?.id;
            const schemaField = renewalAttachmentFields[index];
            if (schemaField?.type === 'attachments' && state.answers?.renewal_response?.[attachmentField]?.length > 0) {
              state.answers.renewal_response[attachmentField] = state.answers.renewal_response[attachmentField]
                .map(item => item?.attachment_id)
                .filter(id => typeof id === 'string');
            }
          }
        }
      }

      const adp_category_id = adpCategories?.find(ele => (ele.name === state.answers?.category_of_adp && ele?.id));
      dataObject = {
        ...dataObject,
        ...state.answers,
        photo: photoId,
        attachments: attachmentId,
        req_attachments: attchList,
        signature: signatureId?.[0] || [],
        adp_category: adp_category_id?.id || null,
        dob: dob && state.answers.dob ? moment(state.answers.dob).format('YYYY-MM-DD') : state.answers.dob,
        lic_exp_date: lic_exp_date && (state.answers.lic_exp_date
          ? moment(state.answers.lic_exp_date).format('YYYY-MM-DD')
          : state.answers.lic_exp_date),
        lic_issue_date: lic_issue_date && (state.answers.lic_issue_date
          ? moment(state.answers.lic_issue_date).format('YYYY-MM-DD')
          : state.answers.lic_issue_date)
      };
      let data = { ...dataObject };
      if (photoId?.length) {
        data.attachments.push(...photoId);
      }
      if (Object.keys(req_attachments)?.length > 0) {
        data.attachments.push(...Object.values(attchList).flat());
      }
      if (allFields.length !== 0) {
        let checkbox = allFields.filter(ele => ele.type === 'boolean');
        if (checkbox?.length !== 0) {
          checkbox.forEach((ele) => {
            if (!data.response[ele.id]) {
              data = { ...data, response: { ...data.response, [ele.id]: false } };
            }
          });
        }
      }
      if (isDraft) {
        dispatch(saveAsDraft(orderId, data));
        setState({ ...state, loader: false });
      } else {
        handleSaveCategoryFee(invoiceObject || {});
        dispatch(submitDp(orderId, data));
      }
    } else {
      setState(prevState => ({
        ...prevState,
        formErrors: true,
        dateError: false
      }));
      if (lic_exp_date && lic_issue_date && expireDate.diff(issueDate) > 0) {
        setState(prevState => ({
          ...prevState,
          dateError: false,
          formErrors: true
        }));
      }
    }
  };

  useEffect(() => {
    if (checkApprovedApplicationAction?.success && state.loader) {
      setState(prevState => ({ ...prevState, loader: false }));
      // CHECK EXISTING APPROVED APPLICATION IF NOT AND GO FOR SUBMIT APPLICATION
      if (!existingApprovedAppInfo?.matching_permits?.length > 0) {
        dispatch(handleClearApprovedApplicationState());
        handelSubmit(false, true);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkApprovedApplicationAction, state, existingApprovedAppInfo]);

  useEffect(() => {
    if ((actionSaveAsDraft?.success || actionSaveAsDraft?.error)
    || (actionDeleteDraftApplication?.success || actionDeleteDraftApplication?.error)) {
      dispatch(handleClearApprovedApplicationState());
      history.push('/adp/myapplications');
    }
  }, [actionSaveAsDraft, dispatch, history, actionDeleteDraftApplication]);

  const handleCheckApprovedApplication = () => {
    const { driving_lic_num } = state.answers;
    setState(prevState => ({ ...prevState, loader: true }));
    dispatch(checkExistingApprovedApplication({ unique_id: driving_lic_num }));
  };

  useEffect(() => {
    if (!(submittedDp?.detail && submitStatus?.success)) return;

    const isPayment = isPaymentAvailable
      && adpSchemaSettings?.settings?.enablePermitFees
      && submittedDp.status === 10;

    const isScheduling = submittedDp.status === 11 && adpSchemaSettings?.settings?.scheduleEnable
      && (submittedDp?.calendar_visibility === 'both' || submittedDp?.calendar_visibility === 'driver');

    if (isPayment) {
      changePage('payment', 'payment');
    } else if (isScheduling) {
      changePage('scheduling', 'scheduling');
    } else {
      changePage('completed', 'completed');
    }

    dispatch(handleClearApprovedApplicationState());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittedDp?.detail, submitStatus?.success]);

  const getErrorAlert = value => setAlert(value);

  const getLoadingStatus = value => setLoad(value);

  const getAnswers = fieldId => ( // Helper function to get answers
    defaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  const fieldAnswers = {};
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };

  const remove = () => {
    dispatch(deleteSaveAsDraftAdpLog(match?.params?.id));
    setConfirmDelete(false);
  };

  return (
    <div className={styles.container}>
      <Loading loadingStatus={state.loader || !allFields?.length} />
      <div className={styles.headder}>
        <FormattedMessage
          id=" "
          defaultMessage={`New ${userProfile?.permit_management_nomenclature?.driver_permit || 'ADP'} Application Form`}
        />
      </div>
      <span className={styles.note}>
        <FormattedMessage
          id="application.note"
          defaultMessage="Please note: "
          tagName="b"
        />
        <FormattedMessage
          id=" "
          defaultMessage={`Renewal ${userProfile?.permit_management_nomenclature?.driver_permit || 'ADP'}
            applications should be submitted through the existing application`}
        />
      </span>
      <div className={styles.childContainer}>
        <CustomFields
          handleAnswerChanged={(a, b) => (handleAnswerChanged(defaultIDs.includes(b) ? 'answers': 'response', a, b))}
          handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
          handleAttachmentFailedAlert={getErrorAlert}
          handleAutoUploadAttachments={uploadtoS3}
          getLoadingStatus={getLoadingStatus}
          entityName="driver_permit"
          showFormErrors={state.formErrors}
          requiredMap={getRequired(allFields)}
          applicationType={state.answers?.application_type}
          fields={allFields}
          answers={fieldAnswers}
          adp
          isSignatureUpload
          forQuestionMarkHelp
        />
        { state.answers.application_type === 'Renewal' && renewalFields?.length > 0 && (
          <CustomFields
            handleAnswerChanged={(a, b) => (handleRenewalAnswerChanged(a, b))}
            handleFieldErrorChanged={(a, b) => handleRenewalFieldErrorChanged(a, b)}
            handleAttachmentFailedAlert={getErrorAlert}
            handleAutoUploadAttachments={uploadtoS3}
            getLoadingStatus={getLoadingStatus}
            entityName="driver_permit"
            showFormErrors={state.formErrors}
            requiredMap={getRenewalRequired(renewalFields)}
            fields={renewalFields}
            answers={state.answers?.renewal_response || {}}
            adp
            applicationType={state.answers?.application_type}
            forQuestionMarkHelp
          />
        )}
        <div>
          <Collapsible
            adp
            title="Note:"
            openOnMount={false}
            collapsibleHeight="0"
          >
            {notes?.length !== 0 && (
              <div style={{ height: 'auto' }}>
                {notes?.map((ele, i) => <p>{`(${i + 1}) ${ele}`}</p>)}
              </div>
            )}
          </Collapsible>
        </div>
        {reqAttach?.length !== 0 && (
          <div>
            <Collapsible
              adp
              title="Required Attachments:"
              openOnMount={false}
              collapsibleHeight="0"
              overflowVisible
            >
                <div style={{ height: 'auto' }}>
                  {reqAttach?.map((ele) => {
                    const attachmentName = typeof ele === 'object' ? ele.attachmentName : ele;
                    return (
                      <ReqAttachments
                        {...staticFields[0]}
                        handleAnswerChanged={(a, b) => handleAnswerChanged(
                          'req_attachments', a, `${attachmentName}_${b}`
                        )}
                        attachments={state.answers?.req_attachments?.[`${typeof ele === 'object'
                          ? ele.attachmentName
                          : ele}_attachments`
                        ]}
                        showFieldErrors={state.formErrors}
                        entityName="driver_permit"
                        getLoadingStatus={getLoadingStatus}
                        handleAutoUploadAttachments={uploadtoS3}
                        handleAttachmentFailedAlert={getErrorAlert}
                        handleRemove={handleRemoveAttachments}
                        adpAttachments
                        attachmentName={attachmentName}
                        dateDetails={ele}
                        adpAnswers={state.answers}
                        handleDateChange={(a, b) => handleAnswerChanged(
                          'req_attachments_dates', a, `${attachmentName}_${b}`
                        )}
                        handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
                      />
                    );
                  })}
                </div>
            </Collapsible>
          </div>
          )}
        <div>
          <CustomFields
            fields={reqAttach?.length > 0 ? staticFields.filter(field => field.title !== 'Attachments'): staticFields}
            answers={state.answers}
            showFormErrors={state.formErrors}
            adp
            adpAttachments
            isSignatureUpload
            entityName="driver_permit"
            applicationType={state.answers?.application_type}
            getLoadingStatus={getLoadingStatus}
            handleAutoUploadAttachments={uploadtoS3}
            handleAttachmentFailedAlert={getErrorAlert}
            handleRemove={handleRemoveAttachments}
            requiredMap={getRequired(staticFields)}
            handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            isCrop={staticFields?.filter(s => s.isCrop === true)}
            profilePic
            forQuestionMarkHelp
          />
        </div>
      </div>
      <div
        className={styles.submitButton}
      >
        <p className={styles.errorMessage}>
          {state.dateError}
        </p>
        {existingApprovedAppInfo?.matching_permits?.length > 0 && (
            <p className={styles.errorMessage}>
                <>
                <FormattedMessage
                  id="adp.existing.application.warning.message"
                  defaultMessage={"Please review the Driver's Licence details, as this already exists."}
                />
                </>
            </p>
          )}
        <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
          {state.answers && state.answers?.status === 14 && (
            <Button
              className={styles.marginRight}
              action="danger"
              onClick={() => handleConfirmDelete()}
              translationID="assets.delete"
              defaultText="Delete"
            />
          )}
          <div style={{ whiteSpace: 'nowrap', margin: '0 5px' }}>
          <Button
            action="primary"
            className={styles.marginRight}
            onClick={() => (handelSubmit(true, true))}
            translationID="inspections.new.finishDraft"
            defaultText={translation['inspections.new.finishDraft']}
            disabled={load}
          />
          </div>
          <Button
            action="secondary"
            onClick={() => (handelSubmit(false, false))}
            translationID="adp.submit"
            defaultText={translation.quizSubmit}
            disabled={load}
          />
        </div>
      </div>
      <DeleteConfirmation
        isActive={confirmDelete}
        onClose={() => toggleConfirmDelete()}
        confirmDelete={() => remove()}
      />
      {alert && <SaveAlert alert={alert} setAlert={setAlert} handelSubmit={() => handelSubmit(true, true)} />}
    </div>
  );
};

export default AdpDriverPublicForm;
